module.exports = __webpack_public_path__ + "static/media/41.e3a17015.png";